<template>
  <el-dialog
      :visible.sync="visible"
      title="物料发货"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      width="90%"
  >
    <el-form
        :model="dataForm"
        :rules="dataRule"
        ref="dataForm"
        label-width="120px"
    >
      <el-row :gutter="16">
        <el-col :span="6">
          <el-form-item label="实际发货时间：" prop="operateDate">
            <el-date-picker
                v-model="dataForm.operateDate"
                type="date"
                value-format="yyyy-MM-dd"
                style="width: 100%"
                placeholder="选择时间"
                size="mini"
            >
            </el-date-picker>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="备注：" prop="remark" label-width="80px" style="margin-bottom: 0;">
            <el-input
                size="mini"
                v-model="dataForm.remark"
                placeholder="备注"
            ></el-input>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row :gutter="16">
        <el-col :span="12">
          <el-form-item label="凭证照片：" prop="imgs" style="margin-bottom: 0;">
            <MultipleImageUpload v-model="dataForm.imgs"></MultipleImageUpload>
          </el-form-item>
        </el-col>
      </el-row>
      <SweetTable :data="dataForm.detailList" :is-page="false" :height="500">
        <el-table-column label="订单编号" prop="orderCode" align="center">
        </el-table-column>
        <el-table-column label="物料名称" prop="product.name" align="center">
        </el-table-column>
        <el-table-column label="颜色" prop="product.color" align="center">
        </el-table-column>
        <el-table-column label="规格" prop="product.size" align="center">
        </el-table-column>
        <el-table-column label="幅宽" prop="product.attr1" align="center">
        </el-table-column>
        <el-table-column label="克重" prop="product.attr2" align="center">
        </el-table-column>
        <el-table-column label="合同数量" prop="orderCount" align="center" width="100">
        </el-table-column>
        <el-table-column label="已发货数量" prop="receivedCount" align="center" width="100">
        </el-table-column>
        <el-table-column label="收货方" prop="receiverName" :show-overflow-tooltip="true" align="center" width="120"
                         :formatter="$c.companyNameFormatter">
        </el-table-column>
        <el-table-column
            label="本次发货数量"
            header-align="center"
            align="center"
            width="120"
        >
          <template v-slot="scope">
            <el-form-item
                :prop="'detailList.' + scope.$index + '.count'"
                :rules="detailRule.count"
                label-width="0"
                style="margin-bottom: 0px"
            >
              <el-input v-model="scope.row.count" size="mini"></el-input>
            </el-form-item>
          </template>
        </el-table-column>
        <el-table-column
            label="发货单价"
            header-align="center"
            align="center"
            width="120"
        >
          <template v-slot="scope">
            <el-form-item
                :prop="'detailList.' + scope.$index + '.price'"
                :rules="detailRule.price"
                label-width="0"
                style="margin-bottom: 0px"
            >
              <el-input v-model="scope.row.price" size="mini"></el-input>
            </el-form-item>
          </template>
        </el-table-column>
      </SweetTable>
    </el-form>
    <template slot="footer">
      <el-button @click="visible=false">{{ $t('cancel') }}</el-button>
      <el-button type="primary" @click="dataFormSubmitHandle">确认发货</el-button>
    </template>
  </el-dialog>
</template>

<script>
/**
 * 发货弹窗
 */
import debounce from 'lodash/debounce'
import MultipleImageUpload from '@/components/MultipleImageUpload'
import { countValidator, moneyValidator } from '@/utils/validate'

export default {
  components: { MultipleImageUpload },
  data () {
    return {
      visible: false,
      dataForm: {},
    }
  },
  computed: {
    detailRule () {
      return {
        count: [
          {
            required: true,
            message: this.$t('validate.required'),
            trigger: 'change',
          },
          {
            validator: countValidator,
            trigger: 'change',
          },
        ],
        price: [
          {
            required: true,
            message: this.$t('validate.required'),
            trigger: 'change',
          },
          {
            validator: moneyValidator,
            trigger: 'change',
          },
        ],
      }
    },
    dataRule () {
      return {
        operateDate: [{
          required: true,
          message: this.$t('validate.required'),
          trigger: 'change',
        }]
      }
    }
  },
  methods: {
    init (detailList) {
      this.dataForm = {
        id: this.dataForm.id,
        remark: '',
        imgs: '',
        detailList: detailList,
      }
      this.visible = true
      this.$nextTick(() => {
        this.$refs.dataForm.clearValidate()
      })
    },
    // 表单提交
    dataFormSubmitHandle:
        debounce(
            function (keep) {
              if (this.loading) {
                return
              }
              this.$refs['dataForm'].validate((valid) => {
                if (!valid) {
                  return false
                }
                let postForm = this.$clone(this.dataForm)
                //物料采购发货
                postForm.type = 10
                if (postForm.detailList.length === 0) {
                  return this.$message.error('请填写发货明细')
                }
                this.loading = true
                this.$api2
                    .post('/erp/receive/save', postForm)
                    .then(res => {
                      this.loading = false
                      this.$c.success('保存成功').then(() => {
                        this.visible = false
                        this.$emit('change')
                      })
                    })
                    .catch((e) => {
                      this.loading = false
                    })
              })
            },
            1000,
            { leading: true, trailing: false }
        )
  },
}
</script>

<style lang="scss" scoped>
.dialog-content {
  max-height: 70vh;
  overflow-y: auto;
}
</style>
